import { ApiResource } from './ApiResource';
import { API_BASE_URL } from './apiUtils';

export interface PostalCodeResponse {
    postalCodes: string[];
}

export const getPostalCodes = async (): Promise<ApiResource<PostalCodeResponse>> => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Postnummer/`, {
            headers: { 'Content-Type': 'application/json' },
            method: 'GET',
        });
        if (!response.ok) {
            return { status: 'error' };
        }
        return {
            status: 'ok',
            data: { postalCodes: (await response.json()) as string[] },
        };
    } catch (error) {
        return { status: 'error' };
    }
};
